import { createSelector } from '@ngrx/store';
import { selectProjectState } from 'app/store/project/project.state';

export const additionalFieldsWithStrings = createSelector(
  selectProjectState,
  state => state.additionFields.additionFieldsWithStrings,
);

export const additionalFieldsWithNumbers = createSelector(
  selectProjectState,
  state => state.additionFields.additionFieldsWithNumbers,
);

export const selectedAdditions = createSelector(
  selectProjectState,
  state => state.additionFields.selectedAdditions.map((field) => {
    if (field.defaultLabel) {
      return field;
    }
    const defaults = [...state.additionFields.additionFieldsWithStrings, ...state.additionFields.additionFieldsWithNumbers];
    return defaults.find(option => option.name === field.name && option.label === field.label) || field;
  }),
);
